import { IClinic, MajorCategories } from '@alpha/types';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { Router } from '@angular/router';

import { DialogService } from 'app-shared-ui';
import { Subject, takeUntil } from 'rxjs';
import { AppLogger, ICardGroupItem, ICardItem } from 'app-core';
import { SearchService } from 'app-service';

import CardType = Data.Core.CardType;

@Component({
  selector: 'app-select-clinic-search',
  templateUrl: './select-clinics.component.html',
  styleUrls: ['./select-clinics.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  viewProviders: [DialogService],
})
export class SelectClinicsComponent implements OnInit, OnDestroy {
  private readonly ngUnsubscribe: Subject<void> = new Subject<void>();
  private listObj: Array<ICardItem> = [];
  public cards: Array<ICardGroupItem> = [];

  public constructor(
    private readonly _cdRef: ChangeDetectorRef,
    private readonly _doctorService: SearchService,
    private readonly _route: Router,
  ) {}

  public ngOnInit(): void {
    this.getClinicProfileByDoctorId();
  }

  private getClinicProfileByDoctorId(): void {
    this._doctorService
      .findAllClinicsByDoctor()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((res: Array<IClinic>) => {
        if (res && res!.length > 0) {
          res.forEach((clinic) => {
            let mobile = 'tel:';
            const contact: string = (mobile +=
              clinic.helpline
                ?.map(
                  (item: any, index: number) =>
                    item,
                )
                .toString() || '');
            this.listObj.push({
              title: clinic.name || '',
              subTitle: clinic.location?.city || '',
              type: MajorCategories.Hospital,
              phone: contact,
              map: clinic.location?.mapURL,
              _id: clinic._id,
              online: clinic.online === undefined ? 0 : clinic.online,
              onArrowClick: (item: any) => {
                this.onArrowClick(clinic!._id!.toString());
              },
            });
          });
          this.cards.push({
            items: this.listObj,
            type: CardType.lg,
          });
        }
        this._cdRef.markForCheck();
      });
  }

  private onArrowClick(id: string): void {
    const route = `/clinic/appointments/${id}`;
    this._route
      .navigate([route], { queryParamsHandling: 'preserve' })
      .catch((err: string | Error) => AppLogger.Error(err));
  }

  public ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
